export default __webpack_public_path__ + "static/media/homeIcon.09f28a71.svg";